import { render, staticRenderFns } from "./AppModalAge.vue?vue&type=template&id=5f773c7e&scoped=true&"
import script from "./AppModalAge.vue?vue&type=script&lang=js&"
export * from "./AppModalAge.vue?vue&type=script&lang=js&"
import style0 from "./AppModalAge.vue?vue&type=style&index=0&id=5f773c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f773c7e",
  null
  
)

export default component.exports